import { CreateFreeElementTool } from '../../canvas-element-tool/CreateFreeElementTool';
import { useCreateTextNode } from './useCreateTextNode';
import { useCanvasFreeElementContext } from '../../canvas-element-tool/CanvasFreeElementContext';

export const CreateTextNodeTool = () => {
  const { createTextNode } = useCreateTextNode();
  const { setCreateElementActive } = useCanvasFreeElementContext();

  return (
    <CreateFreeElementTool
      onCreate={createTextNode}
      onCancel={() => setCreateElementActive(null)}
      cursorPlaceholderText="Add Text"
      createOnClick
    />
  );
};
